module.exports = __webpack_public_path__ + "static/media/exhausted-fatigue-office-syndrome-svgrepo-com.bbe74f09.svg";